"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EProgramType = void 0;
let EProgramType = exports.EProgramType = /*#__PURE__*/function (EProgramType) {
  EProgramType["BASE"] = "base";
  EProgramType["PREFERENTIAL"] = "preferential";
  EProgramType["IT"] = "it";
  EProgramType["FAMILY"] = "family";
  return EProgramType;
}({});